import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Flex } from 'antd';

import Buyable from '../components/Buyable';
import { PaymentSystemList } from '../components/PaymentSystemList';
import {
    useLazyReadPaymentSystemsQuery,
    useUpdatePaymentSystemsMutation,
} from '../service/paymentSettings.api';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';

export const PaymentSettingsContainer = () => {
    const current = useAppSelector(selectShopCurrent);

    const [updateActivePaymentSystem, { isSuccess }] =
        useUpdatePaymentSystemsMutation();

    const [getPaymentSystems, { isLoading, isFetching }] =
        useLazyReadPaymentSystemsQuery();

    useEffect(() => {
        if (current.id) {
            getPaymentSystems(current.id, true);
        }
    }, [current.id]);

    return (
        <Flex vertical justify={'space-between'} wrap={'wrap'} gap={24}>
            <Buyable />
            <PaymentSystemList loading={isLoading || isFetching} />
        </Flex>
    );
};
